<template>
  <ErrorPageLayout
    code="404"
    title="We couldn't find that page"
    description="The link you followed might be broken, or the page may have moved. Let's get you back on track."
    :hint="hintText"
    tone="brand"
  >
    <template #art>
      <svg viewBox="0 0 200 140" width="180" height="126" fill="none" aria-hidden="true">
        <!-- soft halo behind the glass -->
        <ellipse cx="78" cy="74" rx="56" ry="54" fill="url(#p404-halo)" opacity="0.6"/>
        <!-- magnifying glass -->
        <circle cx="78" cy="68" r="38" fill="#ffffff" stroke="#0e5b46" stroke-width="4"/>
        <circle cx="78" cy="68" r="32" fill="url(#p404-lens)"/>
        <!-- "?" inside lens -->
        <text x="78" y="80" font-size="34" font-weight="800" fill="#0e5b46" text-anchor="middle" font-family="ui-sans-serif, system-ui, sans-serif">?</text>
        <!-- glass handle -->
        <line x1="108" y1="98" x2="148" y2="130" stroke="#0e5b46" stroke-width="7" stroke-linecap="round"/>
        <line x1="108" y1="98" x2="148" y2="130" stroke="#16a07a" stroke-width="3" stroke-linecap="round"/>
        <!-- floating dots -->
        <circle cx="160" cy="40" r="4" fill="#16a07a" opacity="0.8">
          <animate attributeName="cy" values="40;30;40" dur="3.5s" repeatCount="indefinite"/>
        </circle>
        <circle cx="40" cy="120" r="3" fill="#0e5b46" opacity="0.6">
          <animate attributeName="cy" values="120;112;120" dur="4s" repeatCount="indefinite"/>
        </circle>
        <circle cx="180" cy="100" r="3" fill="#34d399" opacity="0.7">
          <animate attributeName="cy" values="100;92;100" dur="3s" repeatCount="indefinite"/>
        </circle>
        <defs>
          <radialGradient id="p404-halo">
            <stop offset="0%" stop-color="#16a07a" stop-opacity="0.4"/>
            <stop offset="100%" stop-color="#16a07a" stop-opacity="0"/>
          </radialGradient>
          <linearGradient id="p404-lens" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#f0faf5"/>
            <stop offset="100%" stop-color="#dff5ea"/>
          </linearGradient>
        </defs>
      </svg>
    </template>
  </ErrorPageLayout>
</template>

<script>
import ErrorPageLayout from './ErrorPageLayout.vue'

export default {
  name: 'Page404',
  components: { ErrorPageLayout },
  computed: {
    hintText() {
      const path = this.$route && this.$route.fullPath
      return path && path !== '/pages/404' ? `Requested URL: ${path}` : ''
    },
  },
}
</script>
